<template>
<div class="wait-bid-page page-with-tabbar">
    <van-nav-bar title="竞价中" fixed :placeholder="true">
        <template #right>
            <van-button size="small" type="default" @click="goToHistory" class="records-btn">
                已竞价
            </van-button>
        </template>
    </van-nav-bar>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
    <div class="order-list">
        <van-skeleton v-if="loading && orderList.length === 0" class="product-skeleton" title :row="5" />
        <div v-for="item in orderList" :key="item.order_id" class="order-card">
            <!-- 上部分 -->
            <div class="card-top">
                <div class="top-left">
                    <div class="cinema-name">{{ item.cinema_name }}</div>
                    <div class="order-row">
                        <span class="order-id">{{ item.order_id }}</span>
                        <span class="copy-btn" @click="copyOrderNo(item.order_id)">复制</span>
                    </div>
                </div>
                <div class="top-right">
                    <div class="status-row">
                        <span class="status-text">竞价中</span>
                        <span class="countdown red-text">
                            <template v-if="!item.isFinished">
                                <van-count-down :time="item.remaining * 1000" format="[mm:ss]" @finish="item.isFinished = true" />
                            </template>
                            <template v-else>
                                [已结束]
                            </template>
                        </span>
                    </div>
                    <div class="market-price">市场价:￥{{ item.channel_price }}</div>
                </div>
            </div>
            <!-- 中部分 -->
            <div class="card-middle">
                <div class="movie-img-box">
                    <van-image width="80px" height="100%" fit="cover" :src="item.logo+'_200x200'" />
                </div>
                <div class="movie-info-box">
                    <div class="movie-title-row">
                        <div class="movie-title">{{ item.movie_name }}</div>
                        <div class="city-name">{{ item.city_name }}</div>
                    </div>
                    <div class="showtime-row">
                        <span class="today-tag" v-if="item.play_date_tag">{{ item.play_date_tag }}</span>
                        <span class="showtime">{{ item.play_time_text }}</span>
                    </div>
                    <div class="hall-name" v-if="item.hall_name">{{ item.hall_name }}</div>
                    <div class="movie-tags">
                        <span class="ticket-count">{{ item.quantity }}张</span>
                        <span v-if="item.seatTag === '2'" class="seat-type-tag couple-seat">情侣座</span>
                        <span v-if="item.support_exchange_seat === 'Y'" class="seat-type-tag">九宫格换座</span>
                    </div>
                </div>
            </div>
            <!-- 下部分 -->
            <div class="card-bottom">
                <div class="my-bid">已报价:<span style="color: #ff2c54;font-weight: bold;">￥{{ item.bid_price }}</span></div>
                <div class="action-btns">
                    <van-button size="small" plain type="default" class="action-btn cancel-btn" @click="showCancelDialog(item)" :disabled="item.isFinished">取消报价</van-button>
                    <van-button size="small" type="danger" class="action-btn edit-btn" @click="editBid(item)" :disabled="item.isFinished">修改报价</van-button>
                </div>
            </div>
        </div>
        <van-empty v-if="!loading && orderList.length === 0" class="product-empty" image="search" :description="loadError ? '加载失败，请检查网络后重试' : '暂无竞价中的订单'">
            <van-button size="small" plain type="primary" @click="fetchData">重新加载</van-button>
        </van-empty>
    </div>
    </van-pull-refresh>
    <van-dialog
        v-model="cancelDialogVisible"
        title="取消报价"
        show-cancel-button
        :close-on-click-overlay="false"
        :confirm-button-text="'确认'"
        :cancel-button-text="'取消'"
        @confirm="doCancelBid"
        @cancel="cancelDialogVisible = false"
        class="custom-cancel-dialog"
    >
        <div class="cancel-dialog-content">
            取消后将无法再次参与该订单竞价，确定取消吗？
        </div>
    </van-dialog>
</div>
</template>

<script>
import Api from '@/api-service'
import {
    Toast
} from 'vant'
import { mapMutations } from 'vuex'

export default {
    name: 'WaitBid',
    data() {
        return {
            orderList: [],
            loading: false,
            isFetching: false,
            loadError: false,
            refreshing: false,
            cancelDialogVisible: false,
            cancelBidItem: null,
            timer: null
        }
    },
    created() {
        this.fetchData()
        this.startTimer()
    },
    beforeDestroy() {
        this.clearTimer()
    },
    beforeRouteLeave(to, from, next) {
        this.clearTimer()
        next()
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.startTimer()
        })
    },
    methods: {
        ...mapMutations(['setBidOrderCount']),
        startTimer() {
            this.clearTimer()
            this.timer = setInterval(() => {
                this.fetchData({ silent: true })
            }, 5000)
        },
        clearTimer() {
            if (this.timer) {
                clearInterval(this.timer)
                this.timer = null
            }
        },
        fetchData(options = {}) {
            if (this.isFetching) {
                this.refreshing = false
                return
            }
            const silent = options.silent === true
            this.isFetching = true
            this.loadError = false
            if (!silent) this.loading = true
            Api.getBiddingOrderList({
                page: 1,
                pageSize: 100,
                all: false
            }).then(res => {
                if (!res.list || res.list.length === 0) {
                    this.orderList = []
                    // 更新红点数字为0
                    this.setBidOrderCount(0)
                } else {
                    this.orderList = res.list.map(item => ({
                        ...item,
                        isFinished: item.remaining <= 0
                    }))
                    // 使用服务端同口径总数，避免角标与列表状态不一致
                    const total = Number(res.total)
                    this.setBidOrderCount(Number.isFinite(total) ? total : this.orderList.length)
                }
                this.loading = false
                this.isFetching = false
                this.refreshing = false
            }).catch(() => {
                this.loading = false
                this.isFetching = false
                this.loadError = true
                this.refreshing = false
            })
        },
        onRefresh() {
            this.fetchData()
        },
        showCancelDialog(item) {
            this.cancelBidItem = item
            this.cancelDialogVisible = true
        },
        doCancelBid() {
            if (!this.cancelBidItem) return;
            Api.unbidOrder({ order_id: this.cancelBidItem.order_id }).then(res => {
                Toast.success('取消报价成功');
                this.cancelDialogVisible = false;
                this.fetchData();
            }).catch(() => {
                Toast.fail('取消报价失败');
                this.cancelDialogVisible = false;
            });
        },
        copyOrderNo(orderNo) {
            if (!orderNo) return
            if (navigator && navigator.clipboard) {
                navigator.clipboard.writeText(orderNo).then(() => {
                    Toast('复制成功')
                })
            }
        },
        cancelBid(item) {
            this.showCancelDialog(item)
        },
        editBid(item) {
            const orderData = {
                ...item,
                my_bid_price: item.bid_price
            };
            this.$router.push({ 
                name: 'BidOrderDetail', 
                params: { orderId: item.order_id }, 
                query: { order: encodeURIComponent(JSON.stringify(orderData)) } 
            });
        },
        goToHistory() {
            this.$router.push({ name: 'BidRecords' });
        }
    }
}
</script>

<style lang="scss" scoped>
.wait-bid-page {
    background: #f7f7fa;
    padding-bottom: calc(50px + env(safe-area-inset-bottom, 0px));

    .records-btn {
        font-size: 12px;
        height: 28px;
        padding: 0 12px;
        border-radius: 6px;
        border: 1px solid #667eea;
        background: white;
        color: #667eea;
        font-weight: 500;
        transition: all 0.3s ease;

        &:active {
            background: rgba(102, 126, 234, 0.1);
            transform: scale(0.95);
        }
    }

    .order-list {
        padding: 16px 8px 0 8px;

        .order-card {
            background: #fff;
            border-radius: 10px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
            margin-bottom: 18px;
            padding: 14px 12px 12px 12px;
            display: flex;
            flex-direction: column;

            .card-top {
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                margin-bottom: 8px;

                .top-left {
                    flex: 1;
                    min-width: 0;

                    .cinema-name {
                        font-weight: bold;
                        font-size: 16px;
                        color: #222;
                    }

                    .order-row {
                        display: flex;
                        align-items: center;
                        font-size: 13px;
                        color: #888;
                        margin-top: 2px;

                        .order-id {
                            margin-right: 8px;
                        }

                        .copy-btn {
                            color: #409eff;
                            cursor: pointer;
                        }
                    }
                }

                .top-right {
                    text-align: right;

                    .status-row {
                        display: flex;
                        align-items: center;

                        .status-text {
                            color: #ff2c54;
                            margin-right: 4px;
                            font-size: 13px;
                        }

                        .countdown {
                            color: #d32f2f;
                            font-size: 13px;
                        }
                    }

                    .market-price {
                        font-size: 13px;
                        color: #888;
                        margin-top: 2px;
                    }
                }
            }

            .card-middle {
                display: flex;
                align-items: flex-start;
                margin-bottom: 8px;

                .movie-img-box {
                    width: 80px;
                    height: 100px;
                    border-radius: 4px;
                    margin-right: 12px;
                    overflow: hidden;
                }

                .movie-info-box {
                    flex: 1;
                    min-width: 0;

                    .movie-title-row {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;

                        .movie-title {
                            font-size: 15px;
                            font-weight: 500;
                            color: #333;
                        }

                        .city-name {
                            font-size: 13px;
                            color: black;
                            margin-left: auto;
                        }
                    }

                    .showtime-row {
                        font-size: 13px;
                        color: #333;
                        margin-top: 8px;
                        margin-bottom: 8px;
                        display: flex;
                        align-items: center;
                        gap: 6px;
                    }

                    .today-tag {
                        display: inline-block;
                        color: white;
                        background-color: #ff2c53da;
                        font-size: 12px;
                        font-weight: bold;
                        padding: 2px 6px 2px 4px;
                        margin-right: 2px;
                        line-height: 1.2;
                        vertical-align: middle;
                        border-radius: 2px;
                        clip-path: polygon(0 0,
                                calc(100% - 8px) 0,
                                100% 50%,
                                calc(100% - 8px) 100%,
                                0 100%);
                    }

                    .hall-name {
                        font-size: 13px;
                        color: #888;
                        margin-bottom: 2px;
                    }

                    .movie-tags {
                        margin-top: 4px;

                        .ticket-count {
                            background: #f7f8fa;
                            border-radius: 8px;
                            font-size: 10px;
                            padding: 1px 1px;
                        }

                        .seat-type-tag {
                            border: 2px solid rgb(0, 140, 255);
                            color: rgb(0, 140, 255);
                            border-radius: 2px;
                            font-size: 10px;
                            font-weight: bold;
                            padding: 2px 2px;
                            margin-left: 4px;
                        }
                        
                        .couple-seat {
                            border: 2px solid #ff2c54;
                            color: #ff2c54;
                            background-color: #fff2f0;
                        }
                    }
                }
            }

            .card-bottom {
                display: flex;
                margin-top: 10px;
                justify-content: space-between;
                align-items: center;

                .my-bid {
                    color: black;
                    font-size: 12px;
                }

                .action-btns {
                    display: flex;
                    .action-btn {
                        margin-left: 12px;
                        min-width: 90px;
                    }
                    .cancel-btn {
                        border: 1.5px solid #ff2c54 !important;
                        color: #ff2c54 !important;
                        font-weight: bold;
                    }
                    .edit-btn {
                        font-weight: bold;
                    }
                }
            }
        }

        .empty-tip {
            text-align: center;
            color: #bbb;
            margin-top: 40px;
            font-size: 15px;
        }
    }
}

.countdown.red-text {
    color: #d32f2f;
    font-weight: bold;
    font-size: 14px;

    ::v-deep .van-count-down {
        color: #d32f2f !important;
        font-weight: bold;
        font-size: 14px;
    }
}

::v-deep .custom-cancel-dialog .van-dialog__header {
    font-weight: bold;
    font-size: 20px;
    text-align: center;
    padding-bottom: 0;
}
::v-deep .custom-cancel-dialog .van-dialog__content {
    text-align: center;
    color: #333;
    font-size: 16px;
    line-height: 1.6;
    padding: 18px 18px 0 18px;
}
::v-deep .custom-cancel-dialog .van-dialog__footer {
    display: flex;
    justify-content: space-between;
    gap: 18px;
    padding: 18px 18px 18px 18px;
}
::v-deep .custom-cancel-dialog .van-dialog__cancel,
::v-deep .custom-cancel-dialog .van-dialog__confirm {
    flex: 1;
    border-radius: 24px !important;
    height: 44px;
    font-size: 16px;
    font-weight: bold;
}
::v-deep .custom-cancel-dialog .van-dialog__cancel {
    border: 1.5px solid #d8d8d8 !important;
    color: #888 !important;
    background: #fff !important;
    margin-right: 0;
}
::v-deep .custom-cancel-dialog .van-dialog__confirm {
    background: #ff2c54 !important;
    color: #fff !important;
    border: none !important;
    margin-left: 0;
    box-shadow: 0 2px 8px rgba(255,44,84,0.08);
}
.cancel-dialog-content {
    text-align: center;
    color: #333;
    font-size: 16px;
    margin: 20px 0 10px 0;
}
</style>
